import type {
  ActorDatabase,
  ActorDatabaseConnection,
  ActorRawDatabase,
} from "@-/dev.improve.haniverse.database.actor";
import { useCallback, useMemo } from "react";
import { withDatabaseLoggerProxy } from "@-/dev.improve.haniverse.lib.database.logger";
import { databaseLoggerFromLocation } from "@-/dev.improve.haniverse.lib.logger";
import {
  useGetActorDatabase,
  useGetActorDatabaseConnection,
  useGetActorRawDatabase,
} from "#use-actor-database";

export function useActorDatabaseContextValue(): {
  db: ActorDatabase;
  dbConnection: ActorDatabaseConnection;
  dbRaw: ActorRawDatabase;
} {
  const getActorDatabase = useGetActorDatabase();
  const getActorRawDatabase = useGetActorRawDatabase();
  const getActorDatabaseConnection = useGetActorDatabaseConnection();

  // oxlint-disable-next-line han-no-context-callbacks/no-callbacks-in-context-value -- stable logger-proxy factory keyed on getActorDatabase
  const db = useCallback<ActorDatabase>(
    (location) => withDatabaseLoggerProxy(getActorDatabase, databaseLoggerFromLocation(location)),
    [getActorDatabase],
  );

  // oxlint-disable-next-line han-no-context-callbacks/no-callbacks-in-context-value -- stable logger-proxy factory keyed on getActorRawDatabase
  const dbRaw = useCallback<ActorRawDatabase>(
    (location) =>
      withDatabaseLoggerProxy(getActorRawDatabase, databaseLoggerFromLocation(location)),
    [getActorRawDatabase],
  );
  const dbConnection = useMemo(
    () => withDatabaseLoggerProxy(getActorDatabaseConnection, null),
    [getActorDatabaseConnection],
  );

  return {
    db,
    dbConnection,
    dbRaw,
  };
}
